module.exports = __webpack_public_path__ + "media/application/images/youtube-black-94ecb903239f2796e4f77272140fe93c.svg";